import * as React from "react";

const styles = new Map<string, HTMLStyleElement>();

const UID = `Tldraw-fonts`;
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Caveat+Brush&family=Source+Code+Pro&family=Source+Sans+Pro&family=Crimson+Pro&display=block');
`;

export function useStylesheet() {
  React.useLayoutEffect(() => {
    if (styles.get(UID)) return;
    const style = document.createElement("style");
    style.innerHTML = CSS;
    style.setAttribute("id", UID);
    document.head.appendChild(style);
    styles.set(UID, style);
    // Intentionally no cleanup. Previously this returned a cleanup that
    // removed the `<style>` tag on unmount; combined with the consumer
    // (Tldraw) remounting on some store/suspense transitions, the @import
    // inside got removed and re-added on every mount, which forced the
    // browser to re-evaluate (and in some cases re-fetch) the referenced
    // Google Fonts CSS. The stylesheet is global and meant to live for the
    // session, so we leave it in `<head>` indefinitely.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [UID, CSS]);
}
